module.exports = "../images/bg-race-page-header.jpg";